'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState, useMemo, Suspense } from 'react';
import PropTypes from 'prop-types';
import { InstantSearchNext } from 'react-instantsearch-nextjs';
import { Configure } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { ALGOLIA_INDEX_NAME, NUMBER_OF_PRODUCTS_TO_SHOW, EMPTY_SHOWROOM } from 'commons/constants';
import AdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/AdvancedSearchContext';
import { useTransition } from 'components/consumer/consumer-search/advanced-search-next/hooks/reactShims';
import ShowroomDisplayContext from './hooks/ShowroomDisplayContext';
import CategoryAlgoliaLayout from './components/CategoryAlgoliaLayout';
import TriggerInitialSearch from './components/TriggerInitialSearch';
import ShowroomDataLoader from './components/ShowroomDataLoader';
import categoryPageAlgoliaInstance from './categoryPageAlgoliaInstance';
import useCategoryPageURL from './hooks/useCategoryPageURL';
import buildCategoryAlgoliaConfigureFilters from './buildCategoryAlgoliaConfigureFilters';
const CategoryPageAlgolia = t0 => {
  const $ = _c(53);
  const {
    slug,
    serverCategoryData
  } = t0;
  const [currentProductIndex, setCurrentProductIndex] = useState(ALGOLIA_INDEX_NAME.PRODUCTS);
  const [isReadyToShipActive, setIsReadyToShipActive] = useState(false);
  const [minWidth, setMinWidth] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedColors, setSelectedColors] = useState(t1);
  const [, startTransition] = useTransition();
  const [showroomData, setShowroomData] = useState(EMPTY_SHOWROOM);
  let t2;
  if ($[1] !== startTransition) {
    t2 = indexName => {
      startTransition(() => {
        setCurrentProductIndex(indexName);
      });
    };
    $[1] = startTransition;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateCurrentProductIndex = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = checked => {
      setIsReadyToShipActive(checked);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleToggleReadyToShip = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (min, max) => {
      setMinWidth(min);
      setMaxWidth(max);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleWidthChange = t4;
  let t5;
  if ($[5] !== selectedColors) {
    t5 = colorLabel => {
      const isSelected = !!selectedColors?.[colorLabel];
      setSelectedColors(prev => ({
        ...prev,
        [colorLabel]: !isSelected
      }));
    };
    $[5] = selectedColors;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const selectColor = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setSelectedColors({});
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const clearSelectedColors = t6;
  const [activeTypeFilter, setActiveTypeFilter] = useState(null);
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {};
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const [selectedFacets, setSelectedFacets] = useState(t7);
  const {
    pagesUrlParam,
    updateUrlParamImmediate
  } = useCategoryPageURL(slug);
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = (attribute, value) => {
      setSelectedFacets(prev_0 => {
        const current = prev_0[attribute] || new Set();
        const next = new Set(current);
        if (next.has(value)) {
          next.delete(value);
        } else {
          next.add(value);
        }
        const result = {
          ...prev_0
        };
        if (next.size === 0) {
          delete result[attribute];
        } else {
          result[attribute] = next;
        }
        return result;
      });
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const handleToggleFacet = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setSelectedFacets({});
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const clearSelectedFacets = t9;
  let t10;
  if ($[11] !== activeTypeFilter || $[12] !== currentProductIndex || $[13] !== isReadyToShipActive || $[14] !== maxWidth || $[15] !== minWidth || $[16] !== pagesUrlParam || $[17] !== selectColor || $[18] !== selectedColors || $[19] !== selectedFacets || $[20] !== updateCurrentProductIndex || $[21] !== updateUrlParamImmediate) {
    t10 = {
      currentSearchSection: ALGOLIA_INDEX_NAME.PRODUCTS,
      currentProductIndex,
      updateSearchSection: _temp,
      updateCurrentProductIndex,
      isReadyToShipActive,
      handleToggleReadyToShip,
      minWidth,
      maxWidth,
      handleWidthChange,
      selectedColors,
      selectColor,
      clearSelectedColors,
      pagesUrlParam,
      activeTypeFilter,
      setActiveTypeFilter,
      updateUrlParamImmediate,
      selectedFacets,
      clearSelectedFacets
    };
    $[11] = activeTypeFilter;
    $[12] = currentProductIndex;
    $[13] = isReadyToShipActive;
    $[14] = maxWidth;
    $[15] = minWidth;
    $[16] = pagesUrlParam;
    $[17] = selectColor;
    $[18] = selectedColors;
    $[19] = selectedFacets;
    $[20] = updateCurrentProductIndex;
    $[21] = updateUrlParamImmediate;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const context = t10;
  let t11;
  if ($[23] !== isReadyToShipActive || $[24] !== selectedFacets || $[25] !== slug) {
    t11 = buildCategoryAlgoliaConfigureFilters({
      slug,
      isReadyToShipActive,
      selectedFacets
    });
    $[23] = isReadyToShipActive;
    $[24] = selectedFacets;
    $[25] = slug;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const configureFilters = t11;
  let filters;
  if ($[27] !== maxWidth || $[28] !== minWidth) {
    filters = ["item_availability=0", "visibility>1", "visibility<4"];
    const minNum = parseInt(minWidth, 10);
    const maxNum = parseInt(maxWidth, 10);
    if (!Number.isNaN(minNum) && minNum >= 1) {
      filters.push(`item_width>=${minNum}`);
    }
    if (!Number.isNaN(maxNum) && maxNum <= 300) {
      filters.push(`item_width<=${maxNum}`);
    }
    $[27] = maxWidth;
    $[28] = minWidth;
    $[29] = filters;
  } else {
    filters = $[29];
  }
  const numericFilters = filters;
  let t12;
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      preserveSharedStateOnUnmount: true
    };
    t13 = <TriggerInitialSearch />;
    $[30] = t12;
    $[31] = t13;
  } else {
    t12 = $[30];
    t13 = $[31];
  }
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Suspense fallback={null}><ShowroomDataLoader onLoad={setShowroomData} /></Suspense>;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["*"];
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["_highlightResult", "product_id", "name", "is_in_stock"];
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== configureFilters || $[36] !== numericFilters) {
    t17 = <Configure facets={t15} filters={configureFilters} numericFilters={numericFilters} hitsPerPage={NUMBER_OF_PRODUCTS_TO_SHOW} attributesToRetrieve={t16} clickAnalytics={true} />;
    $[35] = configureFilters;
    $[36] = numericFilters;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== configureFilters || $[39] !== selectedFacets || $[40] !== serverCategoryData || $[41] !== slug) {
    t18 = <CategoryAlgoliaLayout slug={slug} serverCategoryData={serverCategoryData} configureFilters={configureFilters} selectedFacets={selectedFacets} onToggleFacet={handleToggleFacet} onClearFacets={clearSelectedFacets} />;
    $[38] = configureFilters;
    $[39] = selectedFacets;
    $[40] = serverCategoryData;
    $[41] = slug;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== currentProductIndex || $[44] !== t17 || $[45] !== t18) {
    t19 = <InstantSearchNext searchClient={searchClient} indexName={currentProductIndex} instance={categoryPageAlgoliaInstance} future={t12}>{t13}{t14}{t17}{t18}</InstantSearchNext>;
    $[43] = currentProductIndex;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== showroomData || $[48] !== t19) {
    t20 = <ShowroomDisplayContext.Provider value={showroomData}>{t19}</ShowroomDisplayContext.Provider>;
    $[47] = showroomData;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== context || $[51] !== t20) {
    t21 = <AdvancedSearchContext.Provider value={context}>{t20}</AdvancedSearchContext.Provider>;
    $[50] = context;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  return t21;
};
CategoryPageAlgolia.propTypes = {
  slug: PropTypes.string.isRequired,
  serverCategoryData: PropTypes.object
};
export default CategoryPageAlgolia;
function _temp() {}